<template>
  <b-collapse
    class="card"
    :open.sync="isOpen"
  >
    <div
      class="card-header is-padded-small"
      role="button"
      slot="trigger"
    >
      <h3 class="is-size-4 has-margin-horizontal-small">{{ name }}
        <span
          v-if="selected > 0"
          class="is-padded-small is-size-5 has-text-primary"
        > Selected ({{ selected }})</span>
      </h3>
      <div class="flex-pull-right">
        <font-awesome-icon
          class="has-margin-horizontal-small"
          :icon="isOpen ? 'caret-up' : 'caret-down'"
          size="2x"
        />
      </div>
    </div>
    <div class="card-content">
      <div class="content">
        <div v-if="isSubCategorized">
          <b-columns is-multiline>
            <b-column
              v-for="group in Object.keys(options)"
              :key="group"
              class="is-full"
            >
              <p class="has-text-weight-semibold">{{ group }}</p>
              <observation-option-list
                :category-icon="categoryIcon"
                :options="options[group]"
              />
            </b-column>
          </b-columns>
        </div>
        <observation-option-list
          v-else
          :category-icon="categoryIcon"
          :options="options"
        />
      </div>
    </div>
  </b-collapse>
</template>

<script>
import { mapGetters } from 'vuex'
import ObservationOptionList from './ObservationOptionList'

export default {
  components: {
    ObservationOptionList
  },
  props: {
    name: {
      type: String,
      default: 'Category'
    },
    isSubCategorized: {
      type: Boolean,
      default: false
    },
    categoryIcon: {
      type: String,
      default: null,
    },
    options: {
      type: [Array, Object],
      required: true
    }
  },
  data () {
    return {
      isOpen: true
    }
  },
  computed: {
    ...mapGetters(['observationIsSelected']),
    selected () {
      if (this.isSubCategorized) {
        return 0
      }
      return this.options.filter(opt => this.observationIsSelected(opt)).length
    }
  },
}
</script>
